// Central place for WhatsApp business contact.
// NOTE: This number is WhatsApp-only — do NOT label as "phone" anywhere.
export const WHATSAPP_NUMBER = "+49 178 4935355";

const _DIGITS = WHATSAPP_NUMBER.replace(/\D/g, ""); // "491784935355"
export const WHATSAPP_NUMBER_E164 = _DIGITS;

export const whatsappLink = (message = "") => {
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${_DIGITS}${text}`;
};

export const WA_LABEL_DE = "WhatsApp Business";
export const WA_LABEL_EN = "WhatsApp Business";
